import { useState } from 'react'
import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from '@mui/material'
import Address from '../../../../Images/Address.png'
import Payroll from '../../../../Images/Payroll.png'
import Information from '../../../../Images/Information.png'
import Attach from '../../../../Images/Attach.png'
import AddressDetails from './AddressDetails/AddressDetails'
import EmploymentInfo from './EmploymentInfo/EmploymentInfo'
import PayrollDetails from './PayrollDetails/PayrollDetails'
import NotesAndAttachments from './Attachments/NotesAndAttachments'
import employeeManagementStyles from '../../../../styles/employeeManagement.styles'


const EmployeeDetails = ({ onPayrollLoadingChange }) => {
    const [expanded, setExpanded] = useState(0);

    const accordionData = [
        { title: "Payroll Details", icon: Payroll, content: <PayrollDetails onLoadingChange={onPayrollLoadingChange} /> },
        { title: "Address Details", icon: Address, content: <AddressDetails /> },
        { title: "Employment Info", icon: Information, content: <EmploymentInfo /> },
        { title: "Notes & Attachments", icon: Attach, content: <NotesAndAttachments /> }
    ];
    return (
        <Stack gap={1} height={"100%"} overflow={"auto"} >

            {accordionData.map(({ title, icon, content }, idx) => (
                <Accordion
                    key={idx}
                    expanded={expanded === idx}
                    onChange={(event, isExpanded) => setExpanded(isExpanded ? idx : false)}

                >
                    <AccordionSummary
                        expandIcon={<img src={icon} alt="" width={20} height={18} style={{ objectFit: "contain" }} />}
                        sx={employeeManagementStyles.getAccordionSummarySx(expanded === idx)}
                    >
                        <Typography component="span" fontSize={16} fontWeight={700} ml={2}>
                            {title}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        {content}
                    </AccordionDetails>
                </Accordion>
            ))}


        </Stack>
    )
}

export default EmployeeDetails
